import React, { useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import { Stack } from '@domain-group/fe-blueprint-ui/layout';
import { Loader } from '@domain-group/fe-blueprint-ui/loader';
import { Body, DisplaySmall, DisplayMedium } from '@domain-group/fe-blueprint-ui/typography';
import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
import { useSendOnce } from '../../utils/use-send-once';
import { WrappedListingCardGraphQL } from '../wrapped-listing-card';
import { jsx as ___EmotionJSX } from "@emotion/core";
var bodyStyle = /*#__PURE__*/css("margin:0 auto;width:100%;", media('>=tablet', '<desktop'), "{max-width:722px;}");
var center = {
  name: "xi606m",
  styles: "text-align:center;"
};
export var SimilarProperties = _ref => {
  var properties = _ref.properties,
    loading = _ref.loading;
  useSendOnce(!loading && properties.length > 0, 'show-similar-properties');
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile;
  if (loading) {
    return ___EmotionJSX(Stack, {
      vertical: true,
      gap: "m",
      horizontalAlign: "center"
    }, ___EmotionJSX(Body, {
      as: "p"
    }, "Finding similar properties..."), " ", ___EmotionJSX(Loader, null));
  }
  var HeadingText = mobile ? DisplaySmall : DisplayMedium;
  return ___EmotionJSX(Stack, {
    css: bodyStyle,
    vertical: true,
    gap: "m"
  }, ___EmotionJSX(Stack, {
    vertical: true,
    gap: "xxs",
    horizontalAlign: {
      compact: 'center',
      regular: 'start'
    }
  }, ___EmotionJSX(HeadingText, null, "Similar properties to consider"), ___EmotionJSX(Body, {
    css: center
  }, "Properties match some of your search criteria")), ___EmotionJSX(Stack, {
    vertical: true,
    gap: "m"
  }, properties.map(property => ___EmotionJSX(WrappedListingCardGraphQL, {
    appearance: mobile ? 'vertical' : 'horizontal',
    key: property.listing.id,
    property: property
  }))));
};